

export const decodeHtmlEntities = (str) => {
  if (str && typeof str === 'string' && str.length > 0) {
    try {
      const doc = new DOMParser().parseFromString(str, 'text/html');
      let tmp = doc.documentElement.textContent;
      if (tmp) {
        str = tmp;
      }
    } catch (ex) {}
  }
  return str;
};

